import Nav from './components/Nav';
import Hero from './components/Hero';
import ImpactStats from './components/ImpactStats';
import IdentitySection from './components/IdentitySection';
import TransformationRings from './components/TransformationRings';
import TeamSection from './components/TeamSection';
import ActivitiesSection from './components/ActivitiesSection';
import StudentVoices from './components/StudentVoices';
import Footer from './components/Footer';

export default function App() {
  return (
    <>
      <Nav />
      <Hero />
      <ImpactStats />
      <IdentitySection />
      <TransformationRings />
      <TeamSection />
      <ActivitiesSection />
      <StudentVoices />
      <Footer />
    </>
  );
}
